import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_TOPIC_DATA,
  FETCH_TOPIC_CHECKLIST_DATA,
  ADD_TOPIC,
  UPDATE_TOPIC,
  DELETE_TOPIC,
  ADD_CHECKLIST,
  UPDATE_CHECKLIST,
  DELETE_CHECKLIST
} from '../constants/constants';

const initialState = {
  topics: []
};

const findTopic = (state, id) => state.topics.find(topic => topic._id.$oid === id);

const topicsSlice = createSlice({
  name: 'topics',
  initialState,
  reducers: {
    topic_selected: (state, action) => {
      const topic = findTopic(state, action.payload);
      if(topic) topic.selected = !topic.selected;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(FETCH_TOPIC_DATA, (state, action) => {
        state.topics = action.data.map(item => ({
          ...item,
          selected: false,
          checklists: []
        }));
      })
      .addCase(ADD_TOPIC, (state, action) => {
        state.topics = state.topics.concat(action.data);
      })
      .addCase(UPDATE_TOPIC, (state, action) => {
        const topic = findTopic(state, action.data._id.$oid);
        if(topic) topic.title = action.data.title;
      })
      .addCase(DELETE_TOPIC, (state, action) => {
        state.topics = state.topics.filter(topic => topic._id.$oid !== action.data._id.$oid);
      })
      .addCase(FETCH_TOPIC_CHECKLIST_DATA, (state, action) => {
        const topic = findTopic(state, action.id);
        if(topic) topic.checklists = action.data;
      })
      .addCase(ADD_CHECKLIST, (state, action) => {
        const topic = findTopic(state, action.data.topic_id.$oid);
        if(topic) topic.checklists = (topic.checklists || []).concat(action.data);
      })
      .addCase(UPDATE_CHECKLIST, (state, action) => {
        const topic = findTopic(state, action.data.topic_id.$oid);
        if(!topic) return;
        topic.checklists = topic.checklists.map(checklist => (
          checklist._id.$oid == action.data._id.$oid ? action.data : checklist
        ));
      })
      .addCase(DELETE_CHECKLIST, (state, action) => {
        const topic = state.topics.find(topic => topic._id.$oid == action.data.topic_id.$oid);
        if(topic) topic.checklists = topic.checklists.filter(checklist => checklist._id.$oid !== action.data._id.$oid);
      });
  }
});

export const { topic_selected } = topicsSlice.actions;
export default topicsSlice.reducer;
